import { actionCreatorFactory } from 'typescript-fsa';
import { IGridDataHandlers } from '@cbridge-utils/datagrid';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IOption } from '@cbridge-utils/options';
import {
  ISymbolListKey,
  ISymbol,
  ISymbolForm,
  ISymbolList,
  IBaseSymbolsKey,
  ISymbolDetails,
  IBulkUpdateSymbolsPayload,
  IBulkRemoveSymbolsPayload,
} from './symbol.interface';

export namespace SymbolAction {
  const actionCreator = actionCreatorFactory('Symbol');

  export const reload = actionCreator('RELOAD');
  export const load = actionCreator.async<{ symbolId: ISymbol['symbolId'] }, ISymbolDetails, IApiErrorParams>('LOAD');
  export const loadList = actionCreator.async<ISymbolListKey & IGridDataHandlers, ISymbolList, IApiErrorParams>('LOAD_LIST');
  export const loadBaseSymbols = actionCreator.async<IBaseSymbolsKey, IOption[], IApiErrorParams>('LOAD_BASE_SYMBOLS');

  export const create = actionCreator.async<ISymbolForm, { symbolId: ISymbol['symbolId'] }, IApiErrorParams>('CREATE');
  export const update = actionCreator.async<ISymbolForm, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<{ symbolId: ISymbol['symbolId'] }, void, IApiErrorParams>('REMOVE');

  export const bulkUpdate = actionCreator.async<IBulkUpdateSymbolsPayload, void, IApiErrorParams>('BULK_UPDATE');
  export const bulkRemove = actionCreator.async<IBulkRemoveSymbolsPayload, void, IApiErrorParams>('BULK_REMOVE');

  export const processing = actionCreator.async<void, void, void>('PROCESSING');

  export const exportFile = actionCreator.async<
    Pick<ISymbolListKey, 'symbolGroup' | 'search' | 'sort'>, void, IApiErrorParams
  >('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
